import React, { Fragment, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import ScrollToTop from '../Components/Logics/ScrollToTop';
import TopFooter from '../Components/Footer/TopFooter';
import WhatsAppButton from '../Components/Logics/WhatsAppButton';
import { Suspense } from 'react';
import Loading from '../Components/Logics/Loading';
import ScrollProgress from '../Components/Logics/ScrollProgress';

export default function RootLayout() {
    const location = useLocation();
    const theme = useSelector((state) => state.theme.mode);

    const isLoginAndRegisterPage = location.pathname === '/login' || location.pathname === '/register';
    const isDashboardPage = location.pathname === '/Dashboard';
    const isVideoAccessPage = [
        '/SecondSecondary/',
        '/FirstSecondary/',
        '/ThirdSecondary/',
        '/Statistics/',
        '/VideoWatch',
        '/videos/edit/',
        '/profile',
        '/parent',
        '/admin/student/'
    ].some(path => path.endsWith('/') ? location.pathname.startsWith(path) : location.pathname === path);
    // Initialize theme on mount
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    return (
        <Fragment>
            <ScrollToTop />
            <WhatsAppButton />
            <ScrollProgress />
            {!isLoginAndRegisterPage && !isDashboardPage && <Header />}
            <Suspense
                fallback={<article className='d-flex justify-content-center align-items-center'>
                    <Loading />
                </article>}
                key={location.pathname}
            >
                <main>
                    <Outlet />
                </main>
            </Suspense>
            {!isLoginAndRegisterPage && !isDashboardPage && !isVideoAccessPage && <TopFooter />}
            {!isLoginAndRegisterPage && !isDashboardPage && !isVideoAccessPage && <Footer />}
        </Fragment>
    );
}
